import React from 'react';
import { Heart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const HobbiesSection = ({ hobbies, cvService }) => {
  if (!hobbies || hobbies.length === 0) return null;

  return (
    <div className="mb-2">
      {/* Contenu principal */}
      <div className=" backdrop-blur-md rounded-xl p-4 border border-hair shadow-xl">
        <div className="flex items-center mb-8">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-space-600 to-space-700 flex items-center justify-center mr-4 shadow-lg">
            <Heart className="text-white" size={20} />
          </div>
          <h2 className="text-2xl font-bold text-ink tracking-tight">
            {cvService.locale === 'fr' ? 'Centres d\'intérêt' : 'Hobbies'}
          </h2>
        </div>
        
        <Card className="bg-gradient-to-br from-space-800 to-space-900/50 backdrop-blur-sm border-hair shadow-lg rounded-xl overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-space-800 to-space-900 border-b border-hair pb-4">
            <CardTitle className="text-xl font-bold text-ink tracking-tight flex items-center">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-space-600 to-space-700 flex items-center justify-center mr-3 shadow-lg">
                <Heart size={16} className="text-white" />
              </div>
              {cvService.locale === 'fr' ? 'Passions & Loisirs' : 'Passions & Interests'}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 bg-gradient-to-br from-space-800 to-space-900/30">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {hobbies.map((hobby, index) => {
                const label = cvService.getTranslatedValue(hobby.label);
                const description = cvService.getTranslatedValue(hobby.description);

                return (
                  <Card
                    key={index}
                    className="bg-space-800/70 backdrop-blur-sm border-hair hover:bg-space-700 hover:border-hair-bright hover:shadow-md transition-all duration-300 rounded-lg"
                  >
                    <CardContent className="p-4">
                      <h3 className="font-semibold text-ink mb-2 flex items-center text-sm">
                        <div className="w-8 h-8 rounded-full bg-space-700 flex items-center justify-center mr-3 shadow-sm">
                          <Heart size={14} className="text-ink-muted" />
                        </div>
                        {label}
                      </h3>
                      {description && (
                        <p className="text-ink-muted text-xs leading-relaxed font-medium ml-11">
                          {description}
                        </p>
                      )}
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default HobbiesSection;
